export default [
	{
		path: '*',
		redirect: '/home'
	},
	{
		path: '/home',
		name: 'home',
		component: () => import('@/views/home')
	},
	{
		path: '/menu',
		name: 'menu',
		component: () => import('@/views/menu')
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('@/views/login')
	},
	{
		path: '/register',
		name: 'register',
		component: () => import('@/views/register')
	},
	{
		path: '/me',
		name: 'me',
		component: () => import('@/views/personal')
	},
	{
		path: '/menu/member_list',
		name: 'memberList',
		component: () => import('@/views/memberList')
	},
	{
		path: '/menu/payment_record',
		name: 'paymentRecord',
		component: () => import('@/views/paymentRecord')
	},
	{
		path: '/menu/bank_card',
		name: 'bankCardList',
		component: () => import('@/views/bankCardList')
	},
	{
		path: '/menu/betting_record',
		name: 'bettingRecord',
		component: () => import('@/views/bettingRecord')
	},
	{
		path: '/menu/bind_member',
		name: 'bindMember',
		component: () => import('@/views/bindMember')
	},
	{
		path: '/menu/commission_calc',
		name: 'commissionCalculation',
		component: () => import('@/views/commissionCalculation')
	},
	{
		path: '/menu/agent_list',
		name: 'agentList',
		component: () => import('@/views/agentList')
	},
	{
		path: '/menu/agent_balance',
		name: 'agentBalanceChange',
		component: () => import('@/views/agentBalance')
	},
	{
		path: '/menu/agent_settlement',
		name: 'agentSettlement',
		component: () => import('@/views/agentSettlement')
	},
	{
		path: '/menu/agent_withdrawal',
		name: 'agentWithdrawal',
		component: () => import('@/views/agentWithdrawal')
	}
]
